<template>
    <stream-item
        icon="history"
        line-type="dashed"
        class="deal-stream-item"
    >
        <div class="stream-item-deal-header">
            <div class="stream-item-deal-header-left">
                <a class="badge badge-secondary" href="#" @click="showDeal(data)">Archived Deal #{{ data.invoice_number ?? data.id }}</a>
            </div>
            <stream-item-header
                class="stream-item-deal-header-right"
                :created-at="data.stream_date"
            />
        </div>

        <div @click="showDeal(data)" class="stream-item-deal-content" style="font-size: 1.2rem">
            <span class="registration" style="padding: 0.5rem 1rem; max-width: none; width: auto; margin-right: 1rem;">{{ data.vrm }}</span>
            <span>{{ data.manufacturer }} {{ data.model }} {{ data.derivative }}</span>
        </div>
    </stream-item>
</template>

<style lang="scss">
    .deal-stream-item {
        .stream-item-deal-header {
            color: #999;
            padding: 1rem 1rem .5rem;
            display: flex;
        }

        .stream-item-deal-content {
            padding: .5rem 1.5rem 1.75rem;
        }

        .stream-item-deal-header-right {
            padding: 0 .5rem 0 0;
            flex-grow: 1;
            text-align: right;
        }

        .stream-item-deal-header-left {
            padding-left: .5rem;
        }
    }
</style>

<script>
    import StreamItemHeader from './StreamItemHeader'
    import StreamItem from '../../elements/stream/StreamItem'
    import Bus from "../../../events";

    const menuOptions = [
        {
            id: 'delete',
            icon: 'delete',
            label: 'Delete'
        }
    ]

    export default {
        components: { StreamItem, StreamItemHeader },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        methods: {
            showDeal(deal) {
                Bus.emit('showArchivedDeal', { deal })
            }
        }
    }
</script>